import { render, staticRenderFns } from "./TheSideMenu.vue?vue&type=template&id=7035bdd8&scoped=true&"
import script from "./TheSideMenu.vue?vue&type=script&lang=js&"
export * from "./TheSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./TheSideMenu.vue?vue&type=style&index=0&id=7035bdd8&lang=scss&scoped=true&"
import style1 from "./TheSideMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7035bdd8",
  null
  
)

export default component.exports